import {ref, defineExpose} from 'vue'
export default function useValidation() {
    let form = document.getElementById("mainForm") as HTMLFormElement;

    if (form && form != null && form.classList.contains('was-validated')) {
        form.classList.remove('was-validated');
    }
    
    const validatableComponentArray = ref([] as any[]);

    const triggerValidation = () => {
            let isComponentValid = true;
            validatableComponentArray.value.forEach(element => {
                if(element == null){
                    return;
                }

                let isCurrentElementValid = element.isValid() as boolean;
                isComponentValid = isComponentValid && isCurrentElementValid;
            });
            
            return isComponentValid;
    }        

    defineExpose({ triggerValidation });

    const addValidatableComponent = (el:any) => {
        if(validatableComponentArray.value.indexOf(el) == -1) {
            validatableComponentArray.value.push(el);
        }
    };    

    const resetValidatableComponentArray = () => {
        validatableComponentArray.value = [];
    }

    return {
        validatableComponentArray,
        triggerValidation,
        addValidatableComponent,
        resetValidatableComponentArray
    }
}

